import React from 'react';
import groupImgFirst from '../../../../Assets/Images/GroupImgFirst.png';
import groupImgSecond from '../../../../Assets/Images/GroupImgSecond.png';

const LeadershipFlowThirdGroup = () => {
  return (
    <div style={{ padding: '30px 21px', backgroundColor: '#FFFFFF', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative' }}>
      <div>
        {/* Header */}
        {/* <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #00577D', paddingBottom: 5, marginBottom: 2, marginTop: '-15px' }}>
          <div>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#76A3BE' }}>QUADRANT FLOW</div>
            <div style={{ fontSize: 11, fontWeight: 200, color: '#76A3BE' }}>Life & Leadership Assessment</div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', flex: 1 }}>
            <div style={{ fontSize: 8, fontWeight: 700, color: '#76A3BE', textAlign: 'right' }}>Rob Murray</div>
            <div style={{ fontSize: 8, fontWeight: 700, color: '#76A3BE', textAlign: 'right' }}>
              Atlas Real Estate<br />Oct 18, 2024
            </div>
          </div>
        </div> */}

        {/* Header Text */}
        <div style={{ marginTop: 20, fontFamily: 'Lato' }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#426B88', marginBottom: 20, marginTop: 8, textAlign: 'center' }}>GROUP LEADERSHIP FLOW</div>
        </div>

        {/* Images */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '40px', marginTop: 20 }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: 700, fontSize: 18, color: '#426B88', lineHeight: '21px', marginLeft: '22%', marginBottom: 10 }}>OPTION 1</div>
            <img src={groupImgFirst} alt="Option 1" style={{ width: 205, height: 205, marginBottom: 10 }} />
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: 700, fontSize: 18, color: '#426B88', lineHeight: '21px', marginLeft: '22%', marginBottom: 10 }}>OPTION 2</div>
            <img src={groupImgSecond} alt="Option 2" style={{ width: 205, height: 205, marginBottom: 10 }} />
          </div>
        </div>

        {/* Paragraphs */}
        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <div style={{ fontSize: 12, textAlign: 'justify', fontWeight: 400, color: '#245775', marginBottom: 5, fontFamily: 'Lato' }}>
            Quadrant Flow is a leadership framework that focuses on the movement of energy across four essential quadrants: Mind, Strength, Heart, and Soul.
          </div>
          <div style={{ fontSize: 12, textAlign: 'justify', fontWeight: 400, color: '#245775', marginBottom: 5, fontFamily: 'Lato', marginTop: 12 }}>
            Each quadrant reflects a different aspect of leadership: the Mind drives strategic thinking, Strength fuels performance and action, the Heart fosters collaboration and connection, and the Soul represents visionary insight.
          </div>
          <div style={{ fontSize: 12, textAlign: 'justify', fontWeight: 400, color: '#245775', marginBottom: 5, fontFamily: 'Lato', marginTop: 12 }}>
            Unlike rigid personality assessments, Quadrant Flow emphasizes fluidity, showing that leadership flows dynamically between these quadrants. The areas where we flow last—often perceived as weaknesses—are actually opportunities for growth and development.
          </div>
          <div style={{ fontSize: 12, textAlign: 'justify', fontWeight: 400, color: '#245775', marginBottom: 5, fontFamily: 'Lato', marginTop: 12 }}>
            This holistic approach encourages leaders to see potential in every quadrant, deepening self-awareness and fostering balanced, effective leadership.
          </div>
        </div>

        {/* Note */}
        <div style={{ padding: '2% 4% 0 4%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <p style={{ textAlign: 'center' }}>
            <strong style={{ fontSize: 12, fontWeight: 700, fontFamily: 'Lato', color: '#426B88' }}>Note:</strong>
            <span style={{ fontSize: 12, fontWeight: 400, color: '#426B88', lineHeight: 2, letterSpacing: 0 }}> Your group exhibits an equal flow between the Collaborative and Leadership styles, moving seamlessly in both directions.</span>
          </p>
        </div>
      </div>

      {/* Footer */}
      {/* <div style={{ width: 540, borderTop: '1px solid #00577D', paddingTop: 5, display: 'flex', justifyContent: 'space-between', position: 'absolute', bottom: 15, left: 10, right: 21 }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: 10, fontWeight: 700, fontFamily: 'Lato', color: '#76A3BE' }}>SELF REPORT</div>
          <div style={{ fontSize: 8, fontWeight: 400, fontFamily: 'Lato', color: '#76A3BE' }}>
            © Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.
          </div>
        </div>
        <div style={{ fontSize: 10, fontWeight: 700, fontFamily: 'Lato', color: '#76A3BE' }}>PAGE</div>
      </div> */}
    </div>
  );
};

export default LeadershipFlowThirdGroup;
